interface IProps {
  fill?: string;
}

function IConSearchComponent({ fill = "black" }: IProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1585 23.9634L13.7927 14.5976C13.061 15.2561 12.2134 15.7561 11.25 16.0976C10.2866 16.439 9.31707 16.6098 8.34146 16.6098C6.02439 16.6098 4.05488 15.8049 2.43293 14.1951C0.810976 12.5854 0 10.622 0 8.30488C0 5.9878 0.804879 4.02439 2.41463 2.41463C4.02439 0.804878 5.98781 0 8.30488 0C10.622 0 12.5915 0.804878 14.2134 2.41463C15.8354 4.02439 16.6463 5.9878 16.6463 8.30488C16.6463 9.30488 16.4695 10.2866 16.1159 11.25C15.7622 12.2134 15.2561 13.061 14.5976 13.7927L24 23.122L23.1585 23.9634ZM8.34146 15.4756C10.3659 15.4756 12.0732 14.7866 13.4634 13.4085C14.8537 12.0305 15.5488 10.3293 15.5488 8.30488C15.5488 6.28049 14.8537 4.57317 13.4634 3.18293C12.0732 1.79268 10.3659 1.09756 8.34146 1.09756C6.31707 1.09756 4.60976 1.79268 3.21951 3.18293C1.82927 4.57317 1.13415 6.28049 1.13415 8.30488C1.13415 10.3293 1.82927 12.0305 3.21951 13.4085C4.60976 14.7866 6.31707 15.4756 8.34146 15.4756Z"
        fill={fill}
      />
    </svg>
  );
}

export { IConSearchComponent };
